export default __webpack_public_path__ + "static/media/home_icon.ced0b653.svg";